export const resolveHubRefCommitHash = (
  hubRef: string,
  commitHash: string | undefined
) => {
  return hubRef.split(':')[1] === 'latest'
    ? 'latest'
    : commitHash?.slice(0, 8) ?? hubRef.split(':')[1] ?? 'latest';
};

export function replaceCommitHash(
  existingHubRef: string,
  newCommitHash: string
): string {
  const parts = existingHubRef.split(':');
  parts[parts.length - 1] = resolveHubRefCommitHash(
    existingHubRef,
    newCommitHash
  );
  return parts.join(':');
}
